/* tslint:disable */
/* eslint-disable */
/**
 * Warpgate Web Admin
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.22.0-beta.6-6-gfde9e530-modified
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const KubernetesTargetAuthKubernetesTargetCertificateAuthKindEnum = {
    Certificate: 'Certificate'
};
/**
 * Check if a given object implements the KubernetesTargetAuthKubernetesTargetCertificateAuth interface.
 */
export function instanceOfKubernetesTargetAuthKubernetesTargetCertificateAuth(value) {
    if (!('certificate' in value) || value['certificate'] === undefined)
        return false;
    if (!('privateKey' in value) || value['privateKey'] === undefined)
        return false;
    if (!('kind' in value) || value['kind'] === undefined)
        return false;
    return true;
}
export function KubernetesTargetAuthKubernetesTargetCertificateAuthFromJSON(json) {
    return KubernetesTargetAuthKubernetesTargetCertificateAuthFromJSONTyped(json, false);
}
export function KubernetesTargetAuthKubernetesTargetCertificateAuthFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'certificate': json['certificate'],
        'privateKey': json['private_key'],
        'kind': json['kind'],
    };
}
export function KubernetesTargetAuthKubernetesTargetCertificateAuthToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'certificate': value['certificate'],
        'private_key': value['privateKey'],
        'kind': value['kind'],
    };
}
